export const defaultCartStickyHeaderModelData = {
  isTopSectionRendered: false
};
